export default "__VITE_ASSET___2NAIAO8__"